import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'fuse-mail-confirm',
  templateUrl: './mail-confirm.component.html',
  styleUrls: ['./mail-confirm.component.scss'],
  animations: fuseAnimations,
})
export class FuseMailConfirmComponent implements OnInit {
  email = '';

  get userId(): number {
    return LocalStorageManager.regData;
  }

  constructor(private fuseConfigService: FuseConfigService, private activatedRoute: ActivatedRoute) {
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }

  /******************************************************************************/

  ngOnInit(): void {
    this.setEmailFromQueryParams();
  }

  setEmailFromQueryParams(): void {
    this.activatedRoute.queryParams.pipe(filter(params => params.email)).subscribe(params => {
      if (params.email !== undefined && params.email !== '') {
        this.email = params.email;
      }
    });
  }
}
